export const state = {
  data: [],
  rowsCount: 0,
  playlist: [],
  trackData: [],
  performerStorage: [],
  allTracks: [],
  exactTrack: null,
  djMostPopularProducers: [],
  djMostPopularTracks: [],
  producerMostPopularVenues: [],
  producerMostPopulerDjs: [],
  producerMostPopularTracks: [],
  selectedProducerMonth: null,
  selectedTrackMonth: null,
  producerMonthCollapsed: true,
  trackMonthCollapsed: true,
  background: false,
  track: null,
  totalTracksCount: 0,
  playedProducerCount: null,
  preferredCurrency: null,
  year: new Date().getUTCFullYear()
};
